const ACTION_GET_CHART_LIST = 'ACTION_GET_CHART_LIST'
const ACTION_GET_CHART_LIST_SUCCESS = 'ACTION_GET_CHART_LIST_SUCCESS'

export { ACTION_GET_CHART_LIST, ACTION_GET_CHART_LIST_SUCCESS }
